import { format } from 'date-fns';

export function formatDate(date: Date | string | null | undefined): string {
  if (!date) return 'N/A';
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  if (isNaN(dateObj.getTime())) return 'N/A';
  return format(dateObj, 'dd/MM/yyyy HH:mm');
}

export function formatDateOnly(date: Date | string | null | undefined): string {
  if (!date) return 'N/A';
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  if (isNaN(dateObj.getTime())) return 'N/A';
  return format(dateObj, 'dd/MM/yyyy');
}

export function formatPhone(phone: string): string {
  if (!phone) return '';

  const cleaned = phone.replace(/\D/g, '');

  if (cleaned.startsWith('84')) {
    const number = cleaned.substring(2);
    return `+84 ${number.substring(0, 3)} ${number.substring(3, 6)} ${number.substring(6)}`;
  }

  if (cleaned.startsWith('0')) {
    const number = cleaned.substring(1);
    return `0${number.substring(0, 3)} ${number.substring(3, 6)} ${number.substring(6)}`;
  }

  return phone;
}

export function formatAddress(address: string, maxLength: number = 50): string {
  if (!address) return '';

  if (address.length <= maxLength) {
    return address;
  }

  return address.substring(0, maxLength - 3) + '...';
}

export function formatCurrency(amount: number): string {
  return new Intl.NumberFormat('vi-VN', {
    style: 'currency',
    currency: 'VND',
  }).format(amount);
}


/**
 * Ensures a URL uses HTTPS protocol.
 * Fixes mixed content issues when API returns http:// URLs
 * but the app is served over https://.
 */
export function ensureHttps(url: string | null | undefined): string {
  if (!url) return '';
  if (url.startsWith('http://')) {
    return url.replace('http://', 'https://');
  }
  return url;
}
